import { createI18n } from 'vue-i18n'
import zhCN from '../locales/zh-CN.js'
import enUS from '../locales/en-US.js'
import jaJP from '../locales/ja-JP.js'

const cachedLang = localStorage.getItem('app-lang') || 'en-US'

const i18n = createI18n({
  legacy: false,
  locale: cachedLang,
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'ja-JP': jaJP,
  },
})

export default i18n
